module.exports = __webpack_public_path__ + "static/media/pocketcasts.f37ffad8.png";